import { AutogenModelAgencyLink, AutogenRowAgencyLink } from "./autogen/AutogenModelAgencyLink";

export class ModelAgencyLink extends AutogenModelAgencyLink<RowAgencyLink> {
    constructor() {
        super(RowAgencyLink);
    }
}

export class RowAgencyLink extends AutogenRowAgencyLink {
}